import React from "react";
import styled from "styled-components";
import Icon from "design-system/src/Foundation/Icon/Icon";
import { responsiveMap } from "design-system/src/Components/Grid/_utils/responsiveObserve";
import useWidgetLpExitNavigation from "./useWidgetLpExitNavigation";

/** Reprend la croix fiche produit : fond blanc, picto noir (ProductDetails), sticky en haut à droite (web). */
const _WidgetLpCloseRoot = styled.button(() => ({
  position: "fixed",
  top: 26,
  right: 26,
  cursor: "pointer",
  zIndex: 100,
  width: 40,
  height: 40,
  border: "none",
  borderRadius: "100%",
  background: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
  [`@media ${responsiveMap.lg}`]: {
    right: 21,
    top: 26,
  },
}));

const WidgetGroupLpCloseButton = () => {
  const onExit = useWidgetLpExitNavigation();

  return (
    <_WidgetLpCloseRoot type="button" onClick={onExit} aria-label="Fermer">
      <Icon icon="cross_close" size={24} color="#1B1A16" />
    </_WidgetLpCloseRoot>
  );
};

export default WidgetGroupLpCloseButton;
